// src/js/actions/index.js
import { ADD_ARTICLE, FETCH_ANNOUNCEMENT, FETCH_MAP } from "../constants/action-types";
import Axios from "axios";
import _ from 'lodash';

export function addArticle(payload) {
  return { type: ADD_ARTICLE, payload };
}

export function getData() {
    return function(dispatch) {
      return fetch("https://jsonplaceholder.typicode.com/posts")
        .then(response => response.json())
        .then(json => {
          dispatch({ type: "DATA_LOADED", payload: json });
        });
    };
}

export const fetchAnnouncements = (announcements) => {
  return {
    type: FETCH_ANNOUNCEMENT,
    announcements
  }
}

export const fetchAllAnnouncement = () => {
  return (dispatch) => {
    return Axios.get(`https://bcitrch-go.herokuapp.com/GetPostedAnnouncement`)
    .then(res => {
        _.each(res.data.message.postedAnnounceList, (item, index) => {
          item.id = index;
          item.postedTime = Date.now();
          dispatch(fetchAnnouncements(item))
        });
    });
  }
}

export const fetchMaps = (maps) => {
  return {
    type: FETCH_MAP,
    maps
  }
}

export const fetchAllMaps = () => {
  return (dispatch) => {
    return Axios.get(`https://bcitrch-go.herokuapp.com/GetMapList`)
    .then(res => {
        _.each(res.data.message.mapList, (item, index) => {
          item.id = index;
          dispatch(fetchMaps(item))
        })
    });
  }
}